import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type NotificationType = 'error' | 'success';

interface NotificationState {
    message: string;
    type: NotificationType;
}

export type WithNotification<T> = T & { notify: NotificationState };

// Define the initial state using that type
const initialState: NotificationState = { message: '', type: 'success' };

export const notificationSlice = createSlice({
    name: 'notify',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        showNotify: (state, action: PayloadAction<NotificationState>) => {
            return action.payload;
        },
    },
});

export const { showNotify } = notificationSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectNotify = (state: WithNotification<unknown>) => state.notify;

export default notificationSlice.reducer;
